module.exports = __webpack_public_path__ + "img/logo-bej-outlined.8b109505.svg";